<template>
  <div>
    <SCountry :value="computedCountry"
              :placeholder="$tFilter('country_placeholder')"
              :params="vacanciesParams"
              @input="onCountryInput"
              class="main-filter__select"/>
    <SCity v-if="computedCountry"
           :value="computedCity"
           :countryId="computedCountry.id"
           :placeholder="$tFilter('city_placeholder')"
           prefetch
           disabled-on-empty-list
           @input="onCityInput"
           :query="{only_with_vacancies: true}"
           class="main-filter__select"/>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import SCountry from '@/components/loadingSelects/SCountry'
  import SCity from '@/components/loadingSelects/SCity'
  import filterMixin from '@/mixins/filterMixin'

  export default {
    mixins: [filterMixin],
    components: {
      SCountry,
      SCity
    },
    data() {
      return {
        countryInner: null,
        cityInner: null,
      }
    },
    computed: {
      ...mapState('vacancies', [
        'staticRouteFilters',
        'country',
        'city',
        'staticFiltersKeys',
      ]),
      ...mapGetters('vacancies', {
        'vacanciesParams': 'params'
      }),
      computedCountry() {
        const routeCountrySlug = this.staticRouteFilters.country && this.staticRouteFilters.country[0]

        if (routeCountrySlug && routeCountrySlug === (this.country && this.country.id.toString())) {
          return this.country
        }

        return routeCountrySlug ? this.countryInner : null
      },
      computedCity() {
        const routeCitySlug = this.staticRouteFilters.city && this.staticRouteFilters.city[0]

        if (routeCitySlug && routeCitySlug === (this.city && this.city.id.toString())) {
          return this.city
        }

        return routeCitySlug ? this.cityInner : null
      }
    },
    methods: {
      ...mapMutations('vacancies', [
        'updateRouteFilters'
      ]),
      onCountryInput(value) {
        this.countryInner = value

        value = value ? value.id.toString() : null
        this.setStaticFilter(this.staticFiltersKeys.COUNTRY, value)

        this.updateRouteFilters(this.$route)
        setTimeout(() => this.onCityInput(null))
      },
      onCityInput(value) {
        if(this.cityInner === value) return

        this.cityInner = value

        value = value ? value.id.toString() : null
        this.setStaticFilter(this.staticFiltersKeys.CITY, value)
      }
    }
  }
</script>

<style lang="less">

</style>
